import {
  Currency,
  DurationType,
  IBaseModel,
  ICardDetails,
  IClient,
  IIssuePolicyRequest,
  IPolicy,
  IPolicyholder,
  IPolicyStatus,
  IProduct,
  IRiskRequest,
  ISourceOfBusiness,
  PaymentMethod,
} from '@inshuwa-client/models';

interface IFarm extends IBaseModel {
  name?: string;
  clientId: number;
  administrativeAreaId: number;
  camp: IAdministrativeArea;
}

export interface ICropPolicy extends IPolicy {
  farm: IFarm;
  farmId: number;
  crops: string[];
  sumInsured: number;
}

export interface IAdministrativeArea extends IBaseModel {
  name: string;
  level: AreaType;
  parentId?: number;
  parent?: IAdministrativeArea;
  children: IAdministrativeArea[];
  province?: IProvince;
  provinceId?: number;
}

export interface IProvince extends IBaseModel {
  name: string;
  towns: string[];
}

export enum AreaType {
  'Province',
  'District',
  'Block',
  'Camp',
}

export interface IIssueInstantCropPolicyRequest {
  productId: number;
  duration: number;
  startDate: Date;
  endDate?: Date;
  clientId: number;
  combinedPremiumRate: number | null;
  currency?: Currency;
  durationType: DurationType;
  risks: IRiskRequest[];
  sourceOfBusiness: Partial<ISourceOfBusiness>;
  clauses: string[];
  paymentMethod: PaymentMethod;
  cardDetails: ICardDetails | null;
  mobileMoneyAccountNumber: string | null;
  branchId: number | null;
  insuredName?: string;
  nrc?: string;
  policyHolder?: IPolicyholder;
}

export interface IIssueCropPolicy extends IIssuePolicyRequest {
  id: number;
}

export interface IFarmLean extends IBaseModel {
  name?: string;
  clientId: number;
  block?: string;
  camp?: string;
}

export interface IPolicyLean extends IBaseModel {
  policyNumber: string;
  status: IPolicyStatus;
  approvedDate: Date;
  startDate: Date;
  endDate: Date;
  client: IClient | null;
  product: IProduct;
  premiumLevy: number;
  basicPremium: number;
  grossPremium: number;
  currency: Currency;
  insurer: IInsurerLean;
}

export interface ICropPolicyLean extends IPolicyLean {
  farm: IFarmLean;
  farmId: number;
}

export interface IInsurerLean extends IBaseModel {
  name: string;
}

export interface ICropQuotationReport {
  transactionDate: string;
  clientName: string;
  underWriter?: string;
  quotationNumber: string;
  intermediaryName?: string;
  branch?: string;
  product: string;
  camp: string;
  crops: string;
  sumInsured: number;
  grossPremium: number;
  status: string;
}

export interface ICropProductionReport {
  clientName: string;
  nrcNumber: string;
  transactionDate: string;
  underWriter?: string;
  insurer: string;
  policyNumber: string;
  startDate: string;
  monthIssued: string;
  endDate: string;
  intermediaryName?: string;
  partnerName?: string;
  classOfBusiness?: string;
  product: string;
  crops: string;
  branch?: string;
  province?: string;
  district?: string;
  block?: string;
  camp: string;
  sumInsured: number;
  grossPremium: number;
  insuranceLevy: number;
  currency: Currency;
  phoneNumber: string;
}
